import React from "react";
import {PageProcessInterface, ProcessDto} from "../../services/interface/ProcessDtoInterface";
import LoadingPage from "../../components/general/LoadingPage";
import DocumentProcess from "./DocumentProcess";

interface Props {
    loading: boolean;
    listProcess?: PageProcessInterface;
    setListProcess: React.Dispatch<React.SetStateAction<PageProcessInterface | undefined>>;
    setProcessDB: React.Dispatch<React.SetStateAction<ProcessDto | undefined>>;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    setTitle: React.Dispatch<React.SetStateAction<string>>;
}
export default function ListProcess({loading, listProcess, setListProcess, setProcessDB, setOpen, setTitle}: Props): JSX.Element {


    return (
        <div className={`grid ${loading ? '' : 'grid-cols-1'} gap-2`}>
            {loading && <LoadingPage/>}
            {listProcess?.content && listProcess.content?.length > 0 ?
                listProcess.content.map((item, index) => (
                    <DocumentProcess key={`process-${index}`} setOpenCreate={setOpen} {...{item, index, setProcessDB, setTitle}}/>
                )) :
                <>
                </>}
        </div>
    )
}
